import React, { useContext, useEffect } from "react"
import styled from "styled-components"
import GameContext from "../../../Context/GameContext"
import { globalStates } from "../../shared/constants"
import { GlobalIntro } from "../global/GlobalIntro"
import { GlobalOutro } from "../global/GlobalOutro"
import { Reconnect } from "./Reconnect"
import { GlobalRounds } from "../global/GlobalRounds"
import { InfoButton } from "../info-button/InfoButton"

const Wrap = styled.div`
  height: 100vh;
  width: 100vw;
  background-color: ${props => props.theme.colors.secondary};
`

export const OccupiedRoom = props => {
  const { gameState } = useContext(GameContext)
  const globalState = gameState?.globalState

  useEffect(() => {
    if (gameState) console.log({ ...gameState })
  }, [gameState])

  if (globalState)
    switch (globalState) {
      case globalStates.INTRO:
        return <GlobalIntro />
      case globalStates.ROUNDS:
        return <GlobalRounds />
      case globalStates.OUTRO:
        return <GlobalOutro />
      default:
        return <div></div>
    }
  else
    return (
      <Wrap>
        <Reconnect />
      </Wrap>
    )
}
